/**
 * Created by contrapro on 03/04/2018
 */

import wish0 from '../assets/imgs/wishType0.png';
import wish1 from '../assets/imgs/wishType1.png';
import wish2 from '../assets/imgs/wishType2.png';
import wish3 from '../assets/imgs/wishType3.png';

export const MAX_WISH_NUM = 3; //最多愿望数
export const LIGHT_NUM_TO_RELEASE = 10; //收集10个光点可以释放一次

export const VIEW_STATE = {

    HOME: 0,
    SCAN: 1,
    SCAN_FAILED: 2,
    SHARE: 3,
    HOWTO: 4,
};


export const getWishPanelTitle = (viewState) => {
    let title = '';
    switch (viewState) {
        case VIEW_STATE.WISH_SELECTING:
            title = getWish(0).price + "积分点亮你的愿望~";
            break;

        case VIEW_STATE.WISH_DETAIL:
            title = "您选择的愿望主题是：";
            break;

        case VIEW_STATE.WISH_SHARE_PLEASE:
            title = "你的愿望已点亮";
            break;

        default:
            break;
    }
    return title;
};


export const WISH_STATE = {
    NONE: -1,
    FULL: 0,
    HALF: 1,
    EMPTY: 2,
};

const wishConfig = [
    {
        name: 'K11宝贝计划',
        type: 0,
        desc: 'K11宝贝计划\n️',
        price: 100,
        // + '需浇水次数: ' + (plantLevelHPConfig[0].LEVEL_MAX_HP/HP_PER_WATER - 1)
        // + '种植难度: ' + '⭐⭐⭐',
        img: wish0,
    },

    {
        name: '潮人风向标',
        type: 1,
        desc: '潮人风向标\n️',
        price: 100,
        img: wish1,
    },

    {
        name: '吃货的梦想',
        type: 2,
        desc: '吃货的梦想\n️',
        price: 100,
        img: wish2,
    },


    {
        name: '随机小幸运',
        type: 3,
        desc: '随机小幸运\n️',
        price: 100,
        img: wish3,
    },
];

export const getWish = (wishType) => {
    if (wishType > wishConfig.length - 1 || wishType < 0) {
        return null;
    } else {
        return wishConfig[wishType];
    }
};

export const getWishConfigList = wishConfig;

const starConfig = [
    {
        type: 0,    //鸡汤
    },
    {
        type: 1,    //问答
    },
    {
        type: 2,    //抽奖
    },
];

export const getStar = (starType) => {
    if (starType > starConfig.length - 1 || starType < 0) {
        return null;
    } else {
        return starConfig[starType];
    }
};

export const getStarConfigList = starConfig;

const starLightConfig = [
    {
        score: 20,
    },
    {
        score: 60,
    },
    {
        score: 30,
    },
];

export const getStarLight = (index) => {
    if (index > starLightConfig.length - 1 || index < 0) {
        return null;
    } else {
        return starLightConfig[index];
    }
};

export const getStarLightConfigList = starLightConfig;

//-----------------------------
export const MAX_HP_WISH_CARD = 5; //5人助力即得card



//------- message -------
const FIRST_WATER = 'firstWater';
const LEVEL_UP_1 = 'levelUp1';
const LEVEL_UP_END = 'levelUpEnd';
const DEBUFF_REMOVE = 'debuffRemove';
const WATER_24 = 'water24';
const WATER_48 = 'water48';
const WATER_72 = 'water72';
const YYB_USED = 'yybUsed';
const WATER_SUCCESS = 'waterSuccess';
const BONUS_3_PLANT_FAV = 'bonus3PlantFav';
const BONUS_5_PLANT_FAV = 'bonus5PlantFav';

export const msgTypes = {
    FIRST_WATER:FIRST_WATER,
    LEVEL_UP_1: LEVEL_UP_1,
    LEVEL_UP_END: LEVEL_UP_END,
    DEBUFF_REMOVE: DEBUFF_REMOVE,
    WATER_24: WATER_24,
    WATER_48: WATER_48,
    WATER_72: WATER_72,
    YYB_USED: YYB_USED,
    WATER_SUCCESS: WATER_SUCCESS,
    BONUS_3_PLANT_FAV: BONUS_3_PLANT_FAV,
    BONUS_5_PLANT_FAV: BONUS_5_PLANT_FAV,
};

// let messageTypeConfig = null;
export const getMessageConfig = (messageType, params) => {
    let res = {};
    switch (messageType) {
        case FIRST_WATER:
            res = {
                title:'您完成了第一次浇水!',
                content:'再浇' + params[0] + '次水，您的' + params[1] + '就成熟了。植物成熟后您将获得一张兑换券，可在K11线下都市农庄领取奖品!\n' +
                '另外可以用互动积分购买营养包，加速植物生长哦!\n' +
                '成长值: ' + params[2]
            };
            break;

        case LEVEL_UP_1:
            res = {
                title:'第一次升级',
                content:''
            };
            break;

        case LEVEL_UP_END:
            res = {
                title:'成熟了',
                content:''
            };
            break;

        case DEBUFF_REMOVE:
            res = {
                title:'您的植物恢复了健康!',
                content:''
            };
            break;

        case WATER_24:
            res = {
                title:'您的植物口渴啦，快浇水吧!',
                content:'已经24小时没有浇水，快浇水吧!'
            };
            break;

        case WATER_48:
            res = {
                title:'您的植物即将枯萎!',
                content:'已经48小时没有浇水，请多花点时间与爱心呵护它。需要多浇两次水哦!'
            };
            break;

        case WATER_72:
            res = {
                title:'您的植物已经枯萎!',
                content:'已经72小时没有浇水，请再次领取种子重新种植。植物与人一样，都需要细心的呵护，按时浇水，才可以开花结果。继续努力，一定可以成功哦。'
            };
            break;

        case YYB_USED:
            res = {
                title:'使用成功!',
                content: params[0] + '的成长值增加了' + params[1] + '!'
            };
            break;

        case WATER_SUCCESS:
            res = {
                title:'浇水成功!',
                content: '今天还可以浇水' + params[0] + '次，继续加油!\n'
                + '成长值: ' + params[1]
            };
            break;

        case BONUS_3_PLANT_FAV:
            res = {
                title:'Bonus!',
                content: '您已收集了3种植物，获得了' + params[0] + '积分奖励!'
            };
            break;

        case BONUS_5_PLANT_FAV:
            res = {
                title:'Bonus!',
                content: '您已收集了5种植物，获得了' + params[0] + '积分奖励!'
            };
            break;

        default:
            break;
    }

    return res;

};

export const K11_SHOP_URL = 'http://kmall.klub11.com/exchange/MQ==.html?ADTAG=social';

export const HELP_TEXT_URL = '/text/helpTextConfig.json';


// WEBPACK FOOTER //
// ./src/util/constConfig.js